import ScrollUtil from "../common/util/ScrollUtil";

class IssueView {
  // ---------------------------------------------------------------------------------------------------------
  // --	IssueView
  // ---------------------------------------------------------------------------------------------------------

  constructor(dom) {
    //表示したかどうかのフラグ
    this.isEntered = false;

    //dom参照
    this.$dom = dom;
    this.$label = this.$dom.find(".label");
    this.$balloon = this.$dom.find(".balloon");

    //吹き出し初期化
    if (this.$balloon) {
      gsap.set(this.$balloon, {
        scaleX: 0.5,
        scaleY: 0.5,
      });
      this.$balloon.hide();
    }
  }

  enter(delay = 0) {
    if (this.isEntered) return;
    this.isEntered = true;

    //ラベル
    gsap.to(this.$label, 0.2, {
      scaleX: 1.1,
      scaleY: 1.1,
      delay: delay,
    });
    gsap.to(this.$label, 0.6, {
      scaleX: 1.0,
      scaleY: 1.0,
      delay: delay + 0.2,
      ease: "elastic.out(1, 0.8)",
    });

    //吹き出し
    if (this.$balloon) {
      gsap.to(this.$balloon, 0.9, {
        scaleX: 1,
        scaleY: 1,
        delay: delay + 0.1,
        ease: "elastic.out(1, 0.3)",
        onStart: () => {
          this.$balloon.show();
        },
      });
    }
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	SCROLL
  // ---------------------------------------------------------------------------------------------------------

  isInView() {
    return ScrollUtil.isInView(this.$label, 0.5, 1.0);
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default IssueView;
